<template>
  <a-card size="small">
    <template #title>待选列表 - {{ value.length }}项</template>
    <template #extra>
      <a-button size="small" type="link" @click="remove">删除选中</a-button>
    </template>
    <table-wrapper
      :dataSource="value"
      @onSelectionChange="onSelectionChange"
      :columns="columns"
      :tableHeight="tableHeight"
      :showPagination="false"
    ></table-wrapper>
  </a-card>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive, toRefs,Ref,computed } from "vue";
import { columns } from "./constant";
import { LibraryListRecord } from "@/views/material/library/library.interface";

export default defineComponent({
  name: "SelectedTable",
  props: {
    value: {
      type: Array as PropType<LibraryListRecord[]>,
      default: [],
    },
    height:{
      type:Number,
      default:0
    },
    hideColumn: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const state = reactive<{
      current: number;
      selectedIds: string[];
      columns: Ref<any[]>;
      tableHeight:Ref<number>;
    }>({
      current: 1,
      selectedIds: [],
      columns:computed(()=>{
        return columns.filter((item) => !props.hideColumn.includes(item.key));
      }),
      tableHeight:computed(()=>{
        return props.height-122-40;
      })
    });

    const onSelectionChange = (ids: string[]) => {
      state.selectedIds = ids;
    };

    const onTableChange = async (pagination) => {
      state.current = pagination.current;
    };

    const remove = () => {
      const newValue = (props.value || []).filter((item) => !state.selectedIds.includes(item.id));
      emit("update:value", newValue);
    };

    return {
      ...toRefs(state),
      onSelectionChange,
      onTableChange,
      remove,
    };
  },
});
</script>
